import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import React, { useState } from 'react'
import '../asset/css/BuyonlineModal.css'
import CloseIcon from '@mui/icons-material/Close';

const SendMailModal = ({ open, setOpne,handleSendMail,dataForEmail,setDataForEmail,loaderForAddtocart,validateField,validationList,setValidationList }) => {

    


    return (
        <Dialog
            open={open}
            onClose={() => {setOpne(false);setValidationList({})}}
            maxWidth={"lg"}
            className='sendmail_dialog'
        >
            <DialogTitle className='online_heading' style={{ backgroundColor: "#3dcd58" }}>
                <b className='headingtag'>Send Project Details</b>
                <div className='close_icon' onClick={() => { setOpne(false);setValidationList({}) }}><CloseIcon /></div>
            </DialogTitle>
            <DialogContent>
                <TextField id="outlined-basic" label="To" placeholder='To email' variant="outlined" className={validationList?.tofrom ? "error_show":""} value={dataForEmail.to} required={true} onChange={(event) => {setDataForEmail({ ...dataForEmail, to: event.target.value });validateField("toFrom")}} />
                <TextField id="outlined-basic" label="From" placeholder='From email'  variant="outlined" className={validationList?.from ? "error_show":""} required value={dataForEmail.from} onChange={(event) => {setDataForEmail({ ...dataForEmail, from: event.target.value });validateField("from")}} />
                <TextField id="outlined-basic" label="Subject" variant="outlined" value={"test: Material List"} disabled={true} onChange={(event) => setDataForEmail({ ...dataForEmail, subject: event.target.value })} />
                <TextField
                    id="outlined-multiline-flexible"
                    label="Message"
                    multiline
                    maxRows={4}
                    rows={4}
                    onChange={(event) => setDataForEmail({ ...dataForEmail, message: event.target.value })}
                />
            </DialogContent>
            <DialogActions className="project_modal">
                <Button variant="contained" onClick={() => { handleSendMail(dataForEmail) }} autoFocus>Send Mail</Button>
                <Button variant="contained" onClick={() => { setOpne(false);setDataForEmail({});setValidationList({}) }}>Cancel</Button>
            </DialogActions>
            {loaderForAddtocart  && <div className="loader_div">
          <CircularProgress disableShrink />{" "}
        </div>}
        </Dialog>
    )
}

export default SendMailModal